import type { OutsideLienHolder } from '@makemydeal/dr-platform-types';
import type { LienholderFormData } from '../../../types';

export const transformLienholderToDxg = (lienholderData: LienholderFormData): OutsideLienHolder => ({
    lienHolder: lienholderData.lienholder ?? '',
    lienHolderAddress: {
        addressLine1: lienholderData.lienholderAddress?.address ?? '',
        city: lienholderData.lienholderAddress?.city ?? '',
        stateProvince: lienholderData.lienholderAddress?.stateProvince ?? '',
        postalCode: lienholderData.lienholderAddress?.postalCode ?? ''
    },
    lienHolderPhoneNumber: lienholderData.lienholderPhoneNumber ?? ''
});

export const transformLienholderToForm = (sourceOutsideLienholderData: OutsideLienHolder): LienholderFormData => ({
    lienholder: sourceOutsideLienholderData.lienHolder ?? '',
    lienholderAccountNumber: '',
    lienholderPhoneNumber: sourceOutsideLienholderData.lienHolderPhoneNumber ?? '',
    lienholderAddress: {
        address: sourceOutsideLienholderData.lienHolderAddress?.addressLine1 ?? '',
        city: sourceOutsideLienholderData.lienHolderAddress?.city ?? '',
        stateProvince: sourceOutsideLienholderData.lienHolderAddress?.stateProvince ?? '',
        postalCode: sourceOutsideLienholderData.lienHolderAddress?.postalCode ?? ''
    },
    payoffDueDate: null,
    perDiem: 0
});
